module.exports = __webpack_public_path__ + "media/icons/map-pin-c0221746.svg";